import { render, staticRenderFns } from "./sponsors-list.vue?vue&type=template&id=365471d8"
import script from "./sponsors-list.vue?vue&type=script&lang=js"
export * from "./sponsors-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports